import React, { createContext, useState, useEffect, useContext } from 'react'
import { useSnackbar } from 'notistack'
import Button from './Button'

/** context */
const SnackbarContext = createContext()

export const useSnackbarContext = () => useContext(SnackbarContext)

/** provider */
export const SnackbarProviderWrapper = ({ children }) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const [snackbarCount, setSnackbarCount] = useState(0)
  const [lastEnqueueTime, setLastEnqueueTime] = useState(null)

  /** wrapper function to increase count on each enqueue */
  const showSnackbar = (...args) => {
    setSnackbarCount((prev) => prev + 1)
    setLastEnqueueTime(Date.now())
    return enqueueSnackbar(...args)
  }

  /** dismiss all, reset counter */
  const clearSnackbars = () => {
    closeSnackbar()
    setSnackbarCount(0)
  }

  useEffect(() => {
    if (snackbarCount === 0) return

    const timer = setTimeout(() => {
      setSnackbarCount(0)
    }, 5000)

    return () => clearTimeout(timer)
  }, [lastEnqueueTime])

  return (
    <SnackbarContext.Provider value={{ showSnackbar, clearSnackbars, snackbarCount }}>
      {children}
      {snackbarCount > 0 && (
        <div style={{ position: 'fixed', top: '52px', right: '16px', zIndex: 1500 }}>
          <Button
            size="small"
            variant="contained"
            // label="Clear all"
            onClick={clearSnackbars}
            kind="close"
            style={{
              padding: '6px',
              borderRadius: '30%',
              width: '32px',
              height: '32px'
            }}
          />
        </div>
      )}
    </SnackbarContext.Provider>
  )
}
